module.exports = __webpack_public_path__ + "static/Royale-ABOUTPAGE-CNImage-f5748d0491026ce2b79eec0af6309ea6.jpg";